"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = void 0;
class Node {
    constructor(data) {
        if (data) {
            this.id = data.id;
            this.label = data.label;
            this.name = data.name;
        }
    }
}
exports.Node = Node;
//# sourceMappingURL=Node.js.map